var map = {
	"./Cosmos.png": 9194,
	"./FireWoman.png": 3598,
	"./Homem-Aranha.png": 2671,
	"./Homem-de-Ferro.png": 745,
	"./Kaya.png": 3116,
	"./Midas.png": 4639,
	"./Mulher-Maravilha.png": 9226,
	"./Nino.png": 7430,
	"./Sony.png": 6033,
	"./Super-Homem.png": 4409,
	"./Trisoma.png": 5374,
	"./Velocitor.png": 6315,
	"./jogo1.png": 5805,
	"./new-player.png": 9843
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6075;